import React from "react";
import { Plus } from "lucide-react";

interface LoadMoreItemProps {
  onClick?: () => void;
}

const LoadMoreItem = ({ onClick }: LoadMoreItemProps) => {
  return (
    <div
      className="w-full h-[72px] hover:bg-white/5 flex items-center gap-4 px-4 py-3 cursor-pointer transition-colors"
      onClick={onClick}
    >
      <div className="relative w-[48px] h-[48px] flex-shrink-0 overflow-hidden bg-white/10 flex items-center justify-center rounded-lg">
        <Plus className="h-6 w-6 text-gray-800" />
      </div>

      <div className="flex-grow min-w-0">
        <div className="text-sm font-medium text-gray-800">
          Load More Episodes
        </div>
        <div className="text-xs text-gray-600 mt-1">
          Show more from your queue
        </div>
      </div>
    </div>
  );
};

export default LoadMoreItem;
